export default "__VITE_ASSET__DCN6IxYI__"